import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { AboutKolkataLeftMenuList } from "../utils/constants";
import { RenderNavItem } from "../components/RenderNavItem";

const maps = [
  {
    label: "Map of Kolkata Metropolitan Area",
    href: "assets/img/Base-Map-of-Kolkata-Metropolitan-Area.png",
    lightbox: true,
  },
  {
    label: "Wards of Kolkata Municipal Corporation",
    href: "assets/img/902px-KMC_Ward_Map_(Bengali).jpg",
    lightbox: true,
  },
  {
    label: "City Map Of Kolkata",
    href: "assets/img/KOLKATA_RD_big_A0_JOKA_PCE_mayor.pdf",
    lightbox: false,
  },
];

const Map = () => {
  const { t } = useTranslation();
  return (
    <>
      {/* Slider */}
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
          <div className="container">
            <div className="section-main-heading2">
              <h4 className="fontSizeClass"> {t("MAPS")} </h4>
            </div>
          </div>
        </div>
      </section>
      {/* End Slider */}

      <section className="section inner-pad1">
        <div className="container ">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu  ">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {AboutKolkataLeftMenuList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title2">
                    <h3> {t("Maps")} </h3>
                  </div>
                  <div className="col-lg-12 about-head1">
                    {maps.map((item, index) => (
                      <div key={index} className="position-relative map2">
                        <a
                          href={item.href}
                          className={item.lightbox ? "glightbox" : ""}
                          target={!item.lightbox ? "_blank" : undefined}
                          rel={
                            !item.lightbox ? "noopener noreferrer" : undefined
                          }
                        >
                          {t(item.label)}
                        </a>
                      </div>
                    ))}
                    {/* <div className="position-relative map2">
                      <a
                        href="assets/img/Base-Map-of-Kolkata-Metropolitan-Area.png"
                        className="glightbox"
                      >
                        {t("Map of Kolkata Metropolitan Area")}
                      </a>
                    </div>
                    <div className="position-relative map2">
                      <a
                        href="assets/img/902px-KMC_Ward_Map_(Bengali).jpg"
                        className="glightbox"
                      >
                        {t("Wards of Kolkata Municipal Corporation")}
                      </a>
                    </div>
                    <div className="position-relative map2">
                      <a href="assets/img/KOLKATA_RD_big_A0_JOKA_PCE_mayor.pdf">
                        {t("City Map Of Kolkata")}
                      </a>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Map;
